import React, { useState } from 'react';

import { Link, useLocation, useNavigate } from 'react-router-dom';

import { useAuth } from '../contexts/AuthContext';

import { useTippspielBranding } from '../hooks/useTippspielBranding';

import T12Footer from './T12Footer';
import { publicUrl } from '../utils/publicUrl';

const Layout = ({ children }) => {

  const { user, logout, isAdmin } = useAuth();

  const { seasonLabel } = useTippspielBranding();

  const location = useLocation();

  const navigate = useNavigate();

  const [menuOpen, setMenuOpen] = useState(false);



  const nav = [

    { to: '/uebersicht', label: 'Übersicht' },

    { to: '/tippen', label: 'Tippen' },

    { to: '/statistik', label: 'Statistik' },

    { to: '/rangliste', label: 'Rangliste' },

    { to: '/meine-tipps', label: 'Meine Tipps' },
    { to: '/konto', label: 'Konto' },
  ];

  const isActive = (path) => location.pathname.startsWith(path);



  return (

    <div className="page-bg min-h-screen flex flex-col">

      <header className="app-header">

        <div className="max-w-6xl mx-auto px-4 py-3 flex flex-wrap items-center justify-between gap-3">

          <Link to="/uebersicht" className="flex items-center gap-3 group">

            <img src={publicUrl('/assets/t12_logo.svg')} alt="" className="h-9 w-auto opacity-90 group-hover:opacity-100 transition-opacity" />

            <div className="hidden sm:block leading-tight">

              <span className="font-bold text-white tracking-tight">Tippspiel</span>

              <span className="block text-[0.65rem] font-bold uppercase tracking-[0.14em] text-primary">

                Saison {seasonLabel}

              </span>

            </div>

          </Link>



          <button

            type="button"

            className="md:hidden btn-wacker-outline btn-wacker--sm py-1.5 px-3"

            onClick={() => setMenuOpen(!menuOpen)}

          >

            Menü

          </button>



          <nav className={`${menuOpen ? 'flex' : 'hidden'} md:flex flex-wrap gap-1 w-full md:w-auto order-3 md:order-none`}>

            {nav.map((item) => (

              <Link

                key={item.to}

                to={item.to}

                onClick={() => setMenuOpen(false)}

                className={`nav-link ${isActive(item.to) ? 'nav-link-active' : ''}`}

              >

                {item.label}

              </Link>

            ))}

            {isAdmin && (

              <Link

                to="/admin"

                onClick={() => setMenuOpen(false)}

                className={`nav-link ${location.pathname.startsWith('/admin') ? 'nav-link-active' : 'text-amber-300/80'}`}

              >

                Admin

              </Link>

            )}

          </nav>



          <div className="flex items-center gap-3 text-sm order-2 md:order-none ml-auto md:ml-0">

            <span className="text-white/50 hidden sm:inline font-medium">{user?.username}</span>

            <button

              type="button"

              className="btn-wacker-outline btn-wacker--sm py-1.5 px-3"

              onClick={() => { logout(); navigate('/'); }}

            >

              Abmelden

            </button>

          </div>

        </div>

      </header>

      <main className="max-w-6xl mx-auto px-4 py-8 md:py-10 relative z-10 flex-1 w-full">{children}</main>

      <T12Footer />

    </div>

  );

};



export default Layout;


